import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Clock, ArrowRight } from "lucide-react";

export default function BlogPapaDito() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/articles")
      .then(({ data }) => setArticles(data.items || []))
      .catch(() => setArticles([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-[#FAF9F6]">
      {/* HERO */}
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-12">
        <p className="label-eyebrow text-[#C05C45]">Il blog</p>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl text-[#1A362D] tracking-tight leading-[1.05]" data-testid="blog-title">
          Papà dito.
        </h1>
        <p className="mt-4 font-display text-xl sm:text-2xl text-[#5C6B64] leading-snug max-w-3xl">
          Il blog breve che si scorre con il pollice.
        </p>
        <p className="mt-6 font-ui text-base sm:text-lg text-[#5C6B64] leading-relaxed max-w-2xl">
          Piccole pillole per genitori di bambini fino ai <strong>6 anni</strong>: trigger, perché, strategie pratiche. Letture da 2 minuti, da poter fare in fila al supermercato o prima della nanna.
        </p>
      </section>

      {/* ARTICLES LIST */}
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-24" data-testid="blog-articles-list">
        {loading ? (
          <p className="font-ui text-[#8A9691]">Caricamento articoli…</p>
        ) : articles.length === 0 ? (
          <p className="font-ui text-[#8A9691]">Ancora nessun articolo. Torna a trovarci presto!</p>
        ) : (
          <ul className="space-y-8">
            {articles.map((a) => (
              <li key={a.id} data-testid={`blog-card-${a.slug}`}>
                <Link
                  to={`/blog/${a.slug}`}
                  className="group block card-surface overflow-hidden hover:-translate-y-1 transition-all duration-300 hover:shadow-[0_16px_36px_-20px_rgba(26,54,45,0.25)]"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-12 gap-0">
                    {/* Immagine */}
                    <div className="sm:col-span-5 relative bg-[#DCE4DC] aspect-[4/3] sm:aspect-auto sm:min-h-[260px] overflow-hidden">
                      {a.image_url ? (
                        <img
                          src={a.image_url}
                          alt={a.title}
                          className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-700"
                        />
                      ) : (
                        <div className="absolute inset-0 flex items-center justify-center text-6xl opacity-40">📖</div>
                      )}
                    </div>

                    {/* Testo */}
                    <div className="sm:col-span-7 p-6 sm:p-8 lg:p-10 flex flex-col justify-center">
                      <div className="flex flex-wrap items-center gap-3 mb-3">
                        {(a.tags || []).slice(0, 3).map((t) => (
                          <span key={t} className="inline-block px-2.5 py-0.5 rounded-full bg-[#FAF3E7] border border-[#E8DCC4] font-ui text-xs text-[#5C6B64]">
                            {t}
                          </span>
                        ))}
                        <span className="inline-flex items-center gap-1 font-ui text-xs text-[#8A9691]">
                          <Clock size={12} /> {a.reading_time_min} min
                        </span>
                      </div>
                      <h2 className="font-display text-2xl sm:text-3xl text-[#1A362D] leading-tight group-hover:text-[#C05C45] transition-colors">
                        {a.title}
                      </h2>
                      <p className="mt-4 font-ui text-sm sm:text-base text-[#5C6B64] leading-relaxed line-clamp-3">
                        {a.trigger}
                      </p>
                      <span className="mt-5 inline-flex items-center gap-1.5 font-ui text-sm font-medium text-[#C05C45] group-hover:gap-2.5 transition-all">
                        Leggi <ArrowRight size={15} />
                      </span>
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
